import { useTranslation } from 'react-i18next';
import { Box, Paper, Stack, Typography } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import { formatMetricNumber } from './formatNumber';

export function UsageSummaryPanel({ metrics, scope, locale }) {
  const { t } = useTranslation();

  const footerLabel = scope === 'organization' ? t('metrics.members') : t('metrics.platformUsers');
  const footerValue =
    scope === 'organization'
      ? formatMetricNumber(metrics.members?.total, locale)
      : formatMetricNumber(metrics.users?.total, locale);

  return (
    <Paper sx={{ p: { xs: 2, sm: 3 }, height: '100%' }}>
      <Typography variant="h6" gutterBottom>
        {t('metrics.usageSummary')}
      </Typography>
      <Stack spacing={2.5} sx={{ mt: 2 }}>
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography variant="body2">{t('metrics.aiRenders')}</Typography>
            <Typography variant="body2" color="text.secondary">
              {formatMetricNumber(metrics.aiRenders?.thisMonth, locale)}
            </Typography>
          </Box>
          <Typography variant="caption" color="text.secondary">
            {t('metrics.usageThisMonth')}
          </Typography>
        </Box>
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography variant="body2">{t('metrics.optimizations')}</Typography>
            <Typography variant="body2" color="text.secondary">
              {formatMetricNumber(metrics.optimizations?.thisMonth, locale)}
            </Typography>
          </Box>
          <Typography variant="caption" color="text.secondary">
            {t('metrics.usageThisMonth')}
          </Typography>
        </Box>
        <Box sx={{ pt: 1, borderTop: 1, borderColor: 'divider' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <PeopleIcon fontSize="small" color="action" />
            <Typography variant="body2">{footerLabel}</Typography>
          </Box>
          <Typography variant="h5">{footerValue}</Typography>
        </Box>
      </Stack>
    </Paper>
  );
}
